webpackJsonp([34,32],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(759);
	
	var _iview = __webpack_require__(745);
	
	var _iview2 = _interopRequireDefault(_iview);
	
	var _zhCN = __webpack_require__(196);
	
	var _zhCN2 = _interopRequireDefault(_zhCN);
	
	var _router = __webpack_require__(8);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueSwipe = __webpack_require__(853);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _socket = __webpack_require__(197);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _App = __webpack_require__(812);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vue = __webpack_require__(34);
	var VueResource = __webpack_require__(849);
	
	Vue.use(VueResource);
	Vue.http.options.emulateJSON = true;
	
	Vue.use(_iview2.default);
	
	var VueI18n = __webpack_require__(811);
	Vue.use(VueI18n);
	
	Vue.config.lang = 'zh-CN';
	Vue.locale('zh-CN', _zhCN2.default);
	
	_router2.default.beforeEach(function (transition) {
	  _iview2.default.LoadingBar.start();
	  transition.next();
	});
	
	_router2.default.afterEach(function () {
	  _iview2.default.LoadingBar.finish();
	});
	
	Vue.component('swipe', _vueSwipe.Swipe);
	Vue.component('swipe-item', _vueSwipe.SwipeItem);
	
	Vue.use(_socket2.default, 'https://alumni.umiuni.com', _store2.default);
	
	Vue.use(__webpack_require__(851));
	
	Vue.directive('auto-bottom', {
	  deep: true,
	  update: function update() {
	    this.el.scrollTop = this.el.scrollHeight;
	  }
	});
	
	_router2.default.start(_App2.default, 'app');

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var debug = ({"NODE_ENV":"prod"}).API_DEV || false;
	var DEBUG_SERVER = 'http://localhost:5002/api';
	
	var SERVER = debug ? DEBUG_SERVER : '/api';
	
	if (debug) console.log('API SERVER [' + SERVER + ']');exports.default = {
	  'OSS': 'https://oss.umiuni.com/',
	  'user': {
	    'login': SERVER + '/user/login',
	    'getInfo': SERVER + '/user/get',
	    'updateInfo': SERVER + '/user/set',
	    'preRegister': SERVER + '/user/pre_register',
	    'preRegisterGeneric': SERVER + '/user/pre_register_generic',
	    'register': SERVER + '/user/register',
	    'user_signin': SERVER + '/user/user_signin',
	    'verifyEmail': SERVER + '/user/verify_email',
	    'verifyEmailGeneric': SERVER + '/user/verify_email_generic',
	    'verifySession': SERVER + '/user/verify_session',
	    'forgetPassword': SERVER + '/user/forget_password'
	  },
	  'school': {
	    'list': SERVER + '/school/list'
	  },
	  'tag': {
	    'list': SERVER + '/tag/list',
	    'type': SERVER + '/tag/type'
	  },
	  'subject': {
	    'list': SERVER + '/subject/list'
	  },
	  'item': {
	    'publish': SERVER + '/item/set',
	    'list': SERVER + '/item/list',
	    'getInfo': SERVER + '/item/get'
	  },
	  'file': {
	    'upload': SERVER + '/file/upload'
	  },
	  'manage': {
	    'list': SERVER + '/item/private_list'
	  },
	  'like': {
	    'list': SERVER + '/like/list',
	    'add': SERVER + '/like/add',
	    'del': SERVER + '/like/del'
	  },
	  'secure': {
	    'set': SERVER + '/secure/set',
	    'list': SERVER + '/secure/list',
	    'get': SERVER + '/secure/get'
	  },
	  'message': {
	    'get': SERVER + '/message/get',
	    'send': SERVER + '/message/send',
	    'list': SERVER + '/message/list'
	  },
	  'forum': {
	    'list': SERVER + '/forum',
	    'post': {
	      'list': SERVER + '/forum/list_post',
	      'set': SERVER + '/forum/set_post',
	      'up': SERVER + '/forum/set_thumb'
	    },
	    'topic': {
	      'list': SERVER + '/forum/list_topic',
	      'set': SERVER + '/forum/set_topic',
	      'delete': SERVER + '/forum/del_topic'
	    },
	    'info': {
	      'get': SERVER + '/forum/get_fake_info',
	      'set': SERVER + '/forum/set_fake_info'
	    }
	  },
	  'slide': {
	    'list': SERVER + '/slide/list'
	  }
	};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTypes = exports.getStyleIsWide = exports.getSchoolList = exports.getSchool = exports.getSchoolId = exports.getContact = exports.getMessage = exports.isLogin = exports.getUserInfo = undefined;
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUserInfo = exports.getUserInfo = function getUserInfo(state) {
	  return (0, _assign2.default)({
	    userid: null,
	    session: null,
	    username: null,
	    avatar: null,
	    authority: null,
	    balance: null
	  }, state.user);
	};
	
	var isLogin = exports.isLogin = function isLogin(state) {
	  return !!state.user.userid;
	};
	
	var getMessage = exports.getMessage = function getMessage(state) {
	  return state.message.message;
	};
	
	var getContact = exports.getContact = function getContact(state) {
	  return state.message.contact;
	};
	
	var getSchoolId = exports.getSchoolId = function getSchoolId(state) {
	  return state.school.schoolId;
	};
	
	var getSchool = exports.getSchool = function getSchool(state) {
	  return state.school.school;
	};
	
	var getSchoolList = exports.getSchoolList = function getSchoolList(state) {
	  return state.school.schoolList;
	};
	
	var getStyleIsWide = exports.getStyleIsWide = function getStyleIsWide(state) {
	  return state.style.wide;
	};
	
	var getTypes = exports.getTypes = function getTypes(state) {
	  return state.types.types;
	};

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(34);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(854);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _style = __webpack_require__(203);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _user = __webpack_require__(166);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _school = __webpack_require__(202);
	
	var _school2 = _interopRequireDefault(_school);
	
	var _message = __webpack_require__(201);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _types = __webpack_require__(204);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    style: _style2.default,
	    user: _user2.default,
	    school: _school2.default,
	    message: _message2.default,
	    types: _types2.default
	  }
	});

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var Vue = __webpack_require__(34);
	var VueRouter = __webpack_require__(850);
	
	Vue.use(VueRouter);
	
	var router = new VueRouter({
	  history: true,
	  saveScrollPosition: false,
	  transitionOnLoad: true
	});
	
	router.map({
	  '/': {
	    name: 'index',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(191)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/school/:schoolAbbr': {
	    name: 'schoolIndex',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(191)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/help': {
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(821)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    subRoutes: {
	      '/about': {
	        name: 'help-about',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(822)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/faq': {
	        name: 'help-faq',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(824)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/email': {
	        name: 'help-email',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(823)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/business-partnership': {
	        name: 'business-partnership',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(813)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/contact-us': {
	        name: 'contact-us',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(814)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/new-hire': {
	        name: 'new-hire',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(828)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/ban': {
	        name: 'help-ban',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(156)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      }
	    }
	  },
	  '/search': {
	    name: 'search',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(830)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/message': {
	    name: 'message',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(827)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/detail/:iid': {
	    name: 'detail',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(815)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/secure': {
	    name: 'secure',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(831)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/login': {
	    name: 'login',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(826)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/signup': {
	    name: 'signup',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(832)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/forgetpassword': {
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(817)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/sell': {
	    name: 'sell',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/sell/:iid': {
	    name: 'edit',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/u/:userid': {
	    name: 'u',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(833)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/user': {
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(834)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    subRoutes: {
	      '/': {
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(842)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/nav': {
	        name: 'user-nav',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(839)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/like': {
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(836)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/manage': {
	        name: 'user-manage',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(838)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/profile': {
	        name: 'user-profile',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(841)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/forum': {
	        name: 'user-forum',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(835)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/password': {
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(840)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/logout': {
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(837)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      }
	    }
	  },
	  '/forum': {
	    name: 'forum',
	    component: Vue.extend({
	      watch: {
	        '$route': {
	          deep: true,
	          handler: function handler(to) {
	            if (to.name !== 'forum') return;
	            this.redirect();
	          }
	        }
	      },
	      methods: {
	        redirect: function redirect() {
	          router.go({ name: 'forum-list', params: { forumId: 'default' } });
	        }
	      },
	      attached: function attached() {
	        this.redirect();
	      }
	    })
	  },
	  '/forum/list/:forumId': {
	    name: 'forum-list',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(818)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/forum/topic/:ftid': {
	    name: 'forum-topic',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(819)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/ad/statefarm': {
	    name: 'ad-statefarm',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(843)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '*': {
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(825)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/not-found': {
	    name: 'not-found',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(829)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }
	});
	
	router.beforeEach(function () {
	  window.scrollTo(0, 0);
	});
	
	exports.default = router;

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTypes = exports.setStyleWide = exports.setSchoolList = exports.setSchool = exports.fetchMessage = exports.getRecentContactList = exports.sendMessage = exports.socketRegister = exports.userUpdateInfo = exports.userUpdate = exports.userFetch = exports.userLogout = exports.userLogin = undefined;
	
	var _mutationTypes = __webpack_require__(63);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var userLogin = exports.userLogin = function userLogin(_ref, info) {
	  var dispatch = _ref.dispatch;
	
	  dispatch(types.USER_LOGIN, info);
	  dispatch(types.SOCKET_REGISTER, info.userid, info.session);
	};
	
	var userLogout = exports.userLogout = function userLogout(_ref2) {
	  var dispatch = _ref2.dispatch;
	
	  dispatch(types.USER_LOGOUT);
	};
	
	var userFetch = exports.userFetch = function userFetch(_ref3) {
	  var dispatch = _ref3.dispatch;
	
	  dispatch(types.USER_FETCH);
	};
	
	var userUpdate = exports.userUpdate = function userUpdate(_ref4) {
	  var dispatch = _ref4.dispatch;
	
	  dispatch(types.USER_UPDATE);
	};
	
	var userUpdateInfo = exports.userUpdateInfo = function userUpdateInfo(_ref5, info) {
	  var dispatch = _ref5.dispatch;
	
	  dispatch(types.USER_INFO, info);
	};
	
	var socketRegister = exports.socketRegister = function socketRegister(_ref6, userid, session) {
	  var dispatch = _ref6.dispatch;
	
	  dispatch(types.SOCKET_REGISTER, userid, session);
	};
	
	var sendMessage = exports.sendMessage = function sendMessage(_ref7, to, content) {
	  var dispatch = _ref7.dispatch;
	
	  dispatch(types.SOCKET_SEND, to, content);
	};
	
	var getRecentContactList = exports.getRecentContactList = function getRecentContactList(_ref8) {
	  var dispatch = _ref8.dispatch;
	
	  dispatch(types.MESSAGE_RECENT_CONTACT);
	};
	
	var fetchMessage = exports.fetchMessage = function fetchMessage(_ref9, userid) {
	  var dispatch = _ref9.dispatch;
	
	  dispatch(types.MESSAGE_FETCH, userid);
	};
	
	var setSchool = exports.setSchool = function setSchool(_ref10, school) {
	  var dispatch = _ref10.dispatch;
	
	  dispatch(types.SCHOOL_SET, school);
	};
	
	var setSchoolList = exports.setSchoolList = function setSchoolList(_ref11, schoolList) {
	  var dispatch = _ref11.dispatch;
	
	  dispatch(types.SCHOOL_LIST, schoolList);
	};
	
	var setStyleWide = exports.setStyleWide = function setStyleWide(_ref12, wide) {
	  var dispatch = _ref12.dispatch;
	
	  dispatch(types.STYLE_WIDE_SET, wide);
	};
	
	var setTypes = exports.setTypes = function setTypes(_ref13, _types) {
	  var dispatch = _ref13.dispatch;
	
	  dispatch(types.TYPES_SET, _types);
	};

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_LOGIN = exports.USER_LOGIN = 'USER_LOGIN';
	var USER_LOGOUT = exports.USER_LOGOUT = 'USER_LOGOUT';
	var USER_FETCH = exports.USER_FETCH = 'USER_FETCH';
	var USER_UPDATE = exports.USER_UPDATE = 'USER_UPDATE';
	var USER_INFO = exports.USER_INFO = 'USER_INFO';
	
	var SOCKET_CONNECT = exports.SOCKET_CONNECT = 'SOCKET_CONNECT';
	var SOCKET_RECONNECT = exports.SOCKET_RECONNECT = 'SOCKET_RECONNECT';
	var SOCKET_DISCONNECT = exports.SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
	var SOCKET_ERROR = exports.SOCKET_ERROR = 'SOCKET_ERROR';
	var SOCKET_START = exports.SOCKET_START = 'SOCKET_START';
	var SOCKET_INIT = exports.SOCKET_INIT = 'SOCKET_INIT';
	var SOCKET_RECV = exports.SOCKET_RECV = 'SOCKET_RECV';
	var SOCKET_SEND = exports.SOCKET_SEND = 'SOCKET_SEND';
	var SOCKET_LOGOUT = exports.SOCKET_LOGOUT = 'SOCKET_LOGOUT';
	var SOCKET_REGISTER = exports.SOCKET_REGISTER = 'SOCKET_REGISTER';
	var SOCKET_MSG = exports.SOCKET_MSG = 'SOCKET_MSG';
	var MESSAGE_RECENT_CONTACT = exports.MESSAGE_RECENT_CONTACT = 'MESSAGE_RECENT_CONTACT';
	var MESSAGE_FETCH = exports.MESSAGE_FETCH = 'MESSAGE_FETCH';
	
	var SCHOOL_SET = exports.SCHOOL_SET = 'SCHOOL_SET';
	var SCHOOL_LIST = exports.SCHOOL_LIST = 'SCHOOL_LIST';
	
	var STYLE_WIDE_SET = exports.STYLE_WIDE_SET = 'STYLE_WIDE_SET';
	
	var TYPES_SET = exports.TYPES_SET = 'TYPES_SET';

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extractErrorMessage = undefined;
	
	var _typeof2 = __webpack_require__(168);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extractErrorMessage = exports.extractErrorMessage = function extractErrorMessage(response) {
	  console.log(response.body);
	  return response.body && ((0, _typeof3.default)(response.body) === 'object' ? response.body.error : JSON.parse(response.body).error) || response.statusText || 'Undefined Error';
	};

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/qr-wxapp-circle.6ff311e.jpg";

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  bind: function bind() {
	    var _this = this;
	
	    this.documentHandler = function (e) {
	      if (_this.el.contains(e.target)) {
	        return false;
	      }
	      if (_this.expression) {
	        _this.vm[_this.expression]();
	      }
	    };
	    document.addEventListener('click', this.documentHandler);
	  },
	  update: function update() {},
	  unbind: function unbind() {
	    document.removeEventListener('click', this.documentHandler);
	  }
	};

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var camelize = exports.camelize = function camelize(str) {
	  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
	    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
	  }).replace(/[\s-]+/g, '');
	};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventBus = undefined;
	
	var _vue = __webpack_require__(34);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventBus = exports.EventBus = new _vue2.default();

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function getScrollOffsets(_w) {
	  _w = _w || window;
	  if (_w.pageXOffset != null) {
	    return {
	      x: _w.pageXOffset,
	      y: _w.pageYOffset
	    };
	  }
	  var _d = _w.document;
	  return {
	    x: _d.body.scrollLeft,
	    y: _d.body.scrpllTop
	  };
	}
	
	function getViewPortSize(_w) {
	  _w = _w || window;
	  if (_w.innerWidth != null) {
	    return {
	      x: _w.innerWidth,
	      y: _w.innerHeight
	    };
	  }
	  var _d = _w.document;
	  return {
	    x: _d.body.clientWidth,
	    y: _d.body.clientHeight
	  };
	}
	
	var scrollPosition = exports.scrollPosition = function scrollPosition(_obj) {
	  var targetX, targetY;
	  if (!_obj) {
	    targetX = 0;
	    targetY = 70;
	  } else {
	    if (typeof _obj === 'string') {
	      _obj = document.getElementById(_obj);
	    }
	    targetX = _obj.getBoundingClientRect().left + getScrollOffsets().x;
	    targetY = _obj.getBoundingClientRect().top + getScrollOffsets().y;
	  }
	
	  targetY -= 70;
	
	  var maxTargetX = document.body.scrollWidth - getViewPortSize().x;
	  if (targetX >= maxTargetX) targetX = maxTargetX;
	  if (targetX < 0) targetX = 0;
	  var maxTargetY = document.body.scrollHeight - getViewPortSize().y;
	  if (targetY >= maxTargetY) targetY = maxTargetY;
	  if (targetY < 0) targetY = 0;
	
	  clearInterval(window.tempTimer);
	
	  window.tempTimer = setInterval(function () {
	    var currentY = getScrollOffsets().y;
	    var currentX = getScrollOffsets().x;
	    var tempTargetY = currentY - (currentY - targetY) / 13;
	    var tempTargetX = currentX - (currentX - targetX) / 13;
	    if (Math.abs(tempTargetY - currentY) < 1) {
	      tempTargetY - currentY > 0 ? tempTargetY++ : tempTargetY--;
	    }
	    if (Math.abs(tempTargetX - currentX) < 1) {
	      tempTargetX - currentX > 0 ? tempTargetX++ : tempTargetX--;
	    }
	    window.scrollTo(tempTargetX, tempTargetY);
	    if (Math.abs(getScrollOffsets().y - targetY) <= 1 && Math.abs(getScrollOffsets().x - targetX) <= 1) {
	      clearInterval(window.tempTimer);
	      window.scrollTo(targetX, targetY);
	    }
	  }, 10);
	};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(73);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(63);
	
	var _store = __webpack_require__(97);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _store3 = __webpack_require__(5);
	
	var _store4 = _interopRequireDefault(_store3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXPIRE_TIME = 24 * 60 * 60 * 1000;
	
	var storeWithExpiration = {
	  set: function set(key, val, exp) {
	    _store2.default.set(key, { val: val, exp: exp, time: new Date().getTime() });
	  },
	  get: function get(key) {
	    var info = _store2.default.get(key);
	    if (!info) {
	      return null;
	    }
	    if (new Date().getTime() - info.time > info.exp) {
	      return null;
	    }
	    return info.val;
	  }
	};
	
	var state = {
	  userid: null,
	  session: null,
	  username: null,
	  avatar: null,
	  authority: null
	};
	
	var Store = {
	  set: function set() {
	    for (var key in state) {
	      if (!state.hasOwnProperty(key)) continue;
	      storeWithExpiration.set(key, state[key], EXPIRE_TIME);
	    }
	  },
	  get: function get() {
	    var _state = {};
	    for (var key in state) {
	      if (!state.hasOwnProperty(key)) continue;
	
	      _state[key] = storeWithExpiration.get(key);
	    }
	    return _state;
	  },
	  clear: function clear() {
	    for (var key in state) {
	      if (!state.hasOwnProperty(key)) continue;
	      _store2.default.remove(key);
	    }
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_LOGIN, function (state, info) {
	  state = (0, _assign2.default)(state, info);
	  Store.set();
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_LOGOUT, function (state) {
	  for (var key in state) {
	    if (!state.hasOwnProperty(key)) continue;
	    state[key] = null;
	  }
	  Store.clear();
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_FETCH, function (state) {
	  var info = Store.get();
	  state.userid = info.userid;
	  state.session = info.session;
	  _store4.default.dispatch('SOCKET_REGISTER', info.userid, info.session);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_UPDATE, function () {
	  Store.set();
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_INFO, function (state, info) {
	  state.username = info.username;
	  state.avatar = info.avatar;
	  state.authority = info.authority;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fonts/ionicons.2c2ae06.eot";

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  operate: {
	    update: '更新',
	    sell: '发布',
	    search: '搜索',
	    refresh: '刷新',
	    delete: '删除',
	    saveAsDraft: '保存为@:profile.status.draft',
	    reset: '重置',
	    share: '分享',
	    backToTop: '回到顶部',
	    nextPage: '下一页',
	    prevPage: '上一页',
	    switchSchool: '切换学校'
	  },
	  user: {
	    profile: '账户',
	    changePassword: '更改密码',
	    manage: '管理',
	    like: '收藏夹',
	    signup: '注册',
	    login: '登录',
	    logout: '登出',
	    personal: '个人主页',
	    secure: '求购'
	  },
	  profile: {
	    username: '用户名',
	    email: '电子邮箱',
	    experience: '经验值',
	    password: '密码',
	    verifyPassword: '验证密码',
	    forgetPassword: '忘记密码？',
	    noAccount: '还没有账户？',
	    clickToSignup: '点击这里注册',
	    phone: '移动电话',
	    school_switch: '所属/默认发布学校切换',
	    avatar: '头像',
	    category: '分类',
	    itemName: '标题',
	    price: '价格',
	    detail: '详细描述',
	    contact: '联系方式',
	    cover: '封面',
	    status: {
	      all: '全部',
	      selling: '出售中',
	      draft: '草稿',
	      sold: '已售出'
	    }
	  },
	  notify: {
	    noData: '无数据',
	    noPhoto: '无照片',
	    clickToDelete: '点击图片删除',
	    alsoView: '看了该宝贝的人还看了'
	  }
	};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	'use strict';
	
	var _typeof2 = __webpack_require__(168);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	    var Socketio =  true ? __webpack_require__(749) : window.io;
	
	    if (!Socketio) {
	        throw new Error("Cannot locate Socket.io");
	    }
	
	    var VueSocketio = {
	        install: function install(Vue, connection, store) {
	
	            if (!connection) {
	                throw new Error("Cannot locate connection");
	            }
	
	            if (typeof connection === 'string') {
	                var socket = Socketio(connection, {
	                    'transports': ['websocket', 'polling']
	                });
	            } else if ((typeof connection === "undefined" ? "undefined" : (0, _typeof3.default)(connection)) === 'object') {
	                var socket = connection;
	            }
	
	            var onevent = socket.onevent;
	            socket.onevent = function (packet) {
	                var args = packet.data || [];
	                onevent.call(this, packet);
	                packet.data = ["*"].concat(args);
	                onevent.call(this, packet);
	            };
	
	            var methods = ["connect", "error", "disconnect", "reconnect", "reconnect_attempt", "reconnecting", "reconnect_error", "reconnect_failed", "register", "msg"];
	
	            if (!!store) {
	                methods.forEach(function (m) {
	                    socket.on(m, function (data) {
	                        store.dispatch('SOCKET_' + m.toUpperCase(), data);
	                    });
	                });
	
	                store.state.message.$socket = socket;
	            }
	
	            Vue.mixin({
	                created: function created() {
	                    var self = this;
	                    if (this.$options.hasOwnProperty("sockets")) {
	                        socket.on("*", function (emit, data) {
	                            if (self.$options.sockets.hasOwnProperty(emit)) {
	                                self.$options.sockets[emit].call(self, data);
	                            }
	                        });
	
	                        methods.forEach(function (m) {
	                            socket.on(m, function (data) {
	                                if (self.$options.sockets.hasOwnProperty(m)) {
	                                    self.$options.sockets[m].call(self, data);
	                                }
	                            });
	                        });
	                    }
	
	                    this.$socket = socket;
	                }
	            });
	        }
	    };
	
	    if (( false ? "undefined" : (0, _typeof3.default)(exports)) == "object") {
	        module.exports = VueSocketio;
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return VueSocketio;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (window.Vue) {
	        window.VueSocketio = VueSocketio;
	    }
	})();

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(73);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(63);
	
	var _vue = __webpack_require__(34);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _user = __webpack_require__(166);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _api = __webpack_require__(3);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  $socket: null,
	  connect: false,
	  contact: [],
	  message: {}
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SOCKET_CONNECT, function (state) {
	  state.connect = true;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SOCKET_RECONNECT, function (state) {
	  state.connect = true;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SOCKET_DISCONNECT, function (state) {
	  state.connect = false;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SOCKET_REGISTER, function (state, userid, session) {
	  state.$socket.emit('register', {
	    userid: userid,
	    session: session
	  }, function () {});
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SOCKET_MSG, function (state, info) {
	  if (!state.message[info.from]) {
	    if (state.contact.indexOf(info.from) < 0) state.contact.push(info.from);
	    _vue2.default.set(state.message, info.from, []);
	  }
	  state.message[info.from].push(info);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SOCKET_SEND, function (state, to, content) {
	  if (!state.message[to]) {
	    if (state.contact.indexOf(to) < 0) state.contact.push(to);
	    _vue2.default.set(state.message, to, []);
	  }
	  var id = state.message[to].length;
	  state.message[to].push({
	    from: _user2.default.state.userid,
	    to: to, content: content, sent: false
	  });
	  _vue2.default.http.post(_api2.default.message.send, {
	    userid: _user2.default.state.userid,
	    session: _user2.default.state.session,
	    to_userid: to,
	    content: content
	  }).then(function () {
	    state.message[to][id].sent = true;
	  });
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.MESSAGE_RECENT_CONTACT, function (state) {
	  _vue2.default.http.post(_api2.default.message.list, {
	    userid: _user2.default.state.userid,
	    session: _user2.default.state.session
	  }).then(function (res) {
	    state.contact = res.body.contact;
	  });
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.MESSAGE_FETCH, function (state, userid) {
	  _vue2.default.http.post(_api2.default.message.get, {
	    userid: _user2.default.state.userid,
	    session: _user2.default.state.session,
	    to_userid: userid,
	    offset: (state.message[userid] || []).length
	  }).then(function (res) {
	    if (!state.message[userid]) {
	      _vue2.default.set(state.message, userid, []);
	    }
	    for (var i in res.body.message) {
	      res.body.message[i].from = res.body.message[i].from_userid;
	      res.body.message[i].to = res.body.message[i].to_userid;
	      state.message[userid].unshift(res.body.message[i]);
	    }
	  });
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(73);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(63);
	
	var _vue = __webpack_require__(34);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(97);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  school: null,
	  schoolList: null
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SCHOOL_SET, function (state, school) {
	  _store2.default.set('school', school);
	  _vue2.default.set(state, 'school', school);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SCHOOL_LIST, function (state, schoolList) {
	  _store2.default.set('schoolList', schoolList);
	  _vue2.default.set(state, 'schoolList', schoolList);
	}), _mutations);
	
	_vue2.default.set(state, 'school', _store2.default.get('school') || {
	  id: 1,
	  name: 'University of Illinois at Urbana-Champaign',
	  abbr: 'UIUC'
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(73);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(63);
	
	var _vue = __webpack_require__(34);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(97);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  wide: false
	};
	
	var mutations = (0, _defineProperty3.default)({}, _mutationTypes.STYLE_WIDE_SET, function (state, wide) {
	  _store2.default.set('wide', wide);
	  _vue2.default.set(state, 'wide', wide);
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(73);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(63);
	
	var _vue = __webpack_require__(34);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(97);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  types: null
	};
	
	var mutations = (0, _defineProperty3.default)({}, _mutationTypes.TYPES_SET, function (state, types) {
	  _store2.default.set('types', types);
	  _vue2.default.set(state, 'types', types);
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(820);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(816);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _getters = __webpack_require__(4);
	
	var _actions = __webpack_require__(27);
	
	var _schoolSelect = __webpack_require__(846);
	
	var _schoolSelect2 = _interopRequireDefault(_schoolSelect);
	
	var _api = __webpack_require__(3);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'App',
	
	  store: _store2.default,
	  vuex: {
	    actions: {
	      userFetch: _actions.userFetch,
	      setTypes: _actions.setTypes
	    },
	    getters: {
	      school: _getters.getSchool
	    }
	  },
	
	  components: {
	    iHeader: _Header2.default, iFooter: _Footer2.default,
	    schoolSelect: _schoolSelect2.default
	  },
	
	  data: function data() {
	    return {
	      fullHeight: document.documentElement.clientHeight
	    };
	  },
	
	
	  ready: function ready() {
	    this.userFetch();
	    this.getTagType();
	    window.addEventListener('resize', this.handleResize);
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.handleResize);
	  },
	
	  methods: {
	    handleResize: function handleResize() {
	      this.fullHeight = document.documentElement.clientHeight;
	    },
	    getTagType: function getTagType() {
	      var _this = this;
	
	      return this.$http.get(_api2.default.tag.type).then(function (res) {
	        if (res.body) {
	          _this.setTypes(res.body);
	        }
	      });
	    }
	  }
	};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(72);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _scroll = __webpack_require__(165);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _getters = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  vuex: {
	    getters: {
	      types: _getters.getTypes
	    }
	  },
	
	  data: function data() {
	    return {
	      menu: [{
	        title: 'UmiUni',
	        items: [{
	          title: '关于我们',
	          link: 'help-about'
	        }, {
	          title: '联系我们',
	          link: 'contact-us'
	        }, {
	          title: '招聘信息',
	          link: 'new-hire'
	        }, {
	          title: '常见问题',
	          link: 'help-faq'
	        }]
	      }, {
	        title: '账号',
	        items: [{
	          title: '个人主页',
	          link: 'user-nav'
	        }, {
	          title: '校友专属邮箱',
	          link: 'help-email'
	        }, {
	          title: '商业合作',
	          link: 'business-partnership'
	        }]
	      }]
	    };
	  },
	
	
	  methods: {
	    keys: _keys2.default,
	
	    backToTop: function backToTop() {
	      (0, _scroll.scrollPosition)(null);
	    }
	  }
	};

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(72);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(167);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actions = __webpack_require__(27);
	
	var _getters = __webpack_require__(4);
	
	var _api = __webpack_require__(3);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _clickoutside = __webpack_require__(162);
	
	var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
	var _router = __webpack_require__(8);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _eventBus = __webpack_require__(164);
	
	var _camelize = __webpack_require__(163);
	
	var _error = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  directives: { clickoutside: _clickoutside2.default },
	
	  store: _store2.default,
	  vuex: {
	    actions: {
	      userUpdateInfo: _actions.userUpdateInfo, setSchool: _actions.setSchool
	    },
	    getters: {
	      login: _getters.isLogin,
	      info: _getters.getUserInfo,
	      school: _getters.getSchool,
	      types: _getters.getTypes
	    }
	  },
	
	  data: function data() {
	    return {
	      OSS: _api2.default.OSS,
	      menuToggle: false,
	      typeMenuToggle: false,
	      searchToggle: true,
	      tagList: null,
	      query: {
	        type: 'used',
	        name: ''
	      },
	      classToggle: false,
	      locationToggle: false,
	      scrollTop: 0,
	      navFixed: true,
	      timer: null,
	      toggleNavActive: true,
	      toggleQRActive: false,
	      splitedStr: ""
	    };
	  },
	
	
	  computed: {
	    ulStyle: function ulStyle() {
	      return this.$route.name === 'other' ? { maxWidth: '10000px', margin: '0 0 0 10px' } : {};
	    },
	    splitedList: function splitedList(el) {
	      var newArr = [].concat((0, _toConsumableArray3.default)(this.list));
	      newArr.map(function (el) {
	        return el.codes = el.codes.split('+');
	      });
	      return newArr;
	    }
	  },
	
	  watch: {
	    login: {
	      handler: function handler(val, oldVal) {
	        if (val) {
	          this.getInfo();
	        }
	      }
	    },
	    info: {
	      deep: true,
	      handler: function handler(val, oldVal) {}
	    }
	  },
	
	  methods: {
	    keys: _keys2.default,
	    camelize: _camelize.camelize,
	
	    toggleQR: function toggleQR() {
	      this.toggleQRActive = !this.toggleQRActive;
	    },
	    signIn: function signIn() {
	      var _this = this;
	
	      if (this.info.userid) {
	        this.$http.post(_api2.default.user.user_signin, {
	          user_id: this.info.userid,
	          session: this.info.session,
	          signin_text: "Happy and hardwork another day"
	        }).then(function (res) {
	          if (res.body.error) {
	            _this.$Notice.error({
	              title: '签到失败!',
	              desc: (0, _error.extractErrorMessage)(res),
	              duration: 9
	            });
	          } else if (res.body && res.body.userid) {
	            var date = new Date(res.body.last_signin_time);
	            var formattedDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0') + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');
	            _this.$Notice.success({
	              title: '签到成功!' + '签到经验:' + res.body.balance,
	              desc: '上次签到时间：' + formattedDate + '\n需要间隔1分钟',
	              duration: 9
	            });
	          }
	        }, function (res) {
	          _this.$Message.error('Fail: please retry:', res.body.error);
	        });
	      }
	    },
	    getInfo: function getInfo() {
	      var _this2 = this;
	
	      if (this.info.userid) {
	        this.$http.get(_api2.default.user.getInfo, {
	          params: {
	            userid: this.info.userid
	          }
	        }).then(function (res) {
	          if (res.body && res.body.username) {
	            var info = (0, _assign2.default)({}, {
	              username: res.body.username,
	              avatar: res.body.avatar,
	              authority: res.body.authority
	            });
	            _this2.userUpdateInfo(info);
	          }
	        });
	      }
	    },
	    getTagList: function getTagList() {
	      var _this3 = this;
	
	      return this.$http.get(_api2.default.tag.list).then(function (res) {
	        if (res.body) {
	          _this3.tagList = res.body;
	        }
	      });
	    },
	    handleLocationClickOutside: function handleLocationClickOutside() {
	      this.locationToggle = false;
	    },
	    handleMenuClickOutSide: function handleMenuClickOutSide() {
	      this.menuToggle = false;
	    },
	    handleScroll: function handleScroll(e) {
	      if (window.document.body.scrollTop < 200) {
	        this.navFixed = true;
	      } else if (this.scrollTop - window.document.body.scrollTop > 50) {
	        this.navFixed = true;
	        this.scrollTop = window.document.body.scrollTop;
	      } else if (this.scrollTop - window.document.body.scrollTop < -50) {
	        this.navFixed = false;
	        this.scrollTop = window.document.body.scrollTop;
	      }
	    },
	    search: function search() {
	      _router2.default.go({ name: 'search', query: this.query });
	    },
	    forumPost: function forumPost() {
	      if (!this.login) {
	        _router2.default.go({ name: 'login' });
	        return;
	      }
	      if (this.$route.name !== 'forum-list') {
	        _router2.default.go({ name: 'forum-list', params: { forumId: 'default' }, query: { new: 'true' } });
	      }
	      _eventBus.EventBus.$emit('forum-post');
	    }
	  },
	
	  ready: function ready() {
	    var _this4 = this;
	
	    this.getTagList();
	    this.$nextTick(function () {
	      _this4.scrollTop = window.document.body.scrollTop;
	      setTimeout(window.addEventListener('scroll', _this4.handleScroll, false), 1000);
	    });
	  },
	  beforeDestory: function beforeDestory() {
	    window.removeEventListener('scroll', this.handleScroll);
	  },
	
	
	  splitedStrFunction: function splitedStrFunction() {
	
	    this.splitedStr = this.str.split(" ");
	  }
	
	};

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(72);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _api = __webpack_require__(3);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _getters = __webpack_require__(4);
	
	var _actions = __webpack_require__(27);
	
	var _lodash = __webpack_require__(39);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _router = __webpack_require__(8);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SchoolSelect',
	
	  store: _store2.default,
	  vuex: {
	    actions: {
	      setSchool: _actions.setSchool
	    },
	    getters: {
	      school: _getters.getSchool
	    }
	  },
	
	  props: {
	    visible: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      schoolList: {},
	      currentState: 'hot'
	    };
	  },
	
	
	  computed: {
	    stateList: function stateList() {
	      return (0, _keys2.default)(this.schoolList);
	    },
	    currentSchoolList: function currentSchoolList() {
	      return this.schoolList[this.currentState] || [];
	    }
	  },
	
	  methods: {
	    getSchoolList: function getSchoolList() {
	      var _this = this;
	
	      this.$http.get(_api2.default.school.list).then(function (res) {
	        res.body.hot = _lodash2.default.chain(res.body).get('school').filter('hot').value();
	        delete res.body.school;
	        _this.schoolList = res.body;
	      });
	    },
	    handleSchoolClick: function handleSchoolClick(school) {
	      this.setSchool(school);
	      _router2.default.go({ name: 'schoolIndex', params: { schoolAbbr: school.abbr } });
	    }
	  },
	
	  ready: function ready() {
	    this.getSchoolList();
	  }
	};

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/icon.ico";

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fonts/ionicons.24712f6.ttf";

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fonts/ionicons.05acfdb.woff";

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ionicons.621bd38.svg";

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/qr_circle_wechat_mini_mobile_2021.242bc07.jpg";

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

	module.exports = " <div id=app> <i-header></i-header> <div class=main :style=\"{ minHeight: fullHeight+'px' }\"> <router-view keep-alive></router-view> </div> <school-select :visible=!school></school-select> <i-footer></i-footer> </div> ";

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <header class=unselectable :class=\"{ fixed: !navFixed }\" _v-013e472d=\"\"> <ul :style=ulStyle _v-013e472d=\"\"> <li _v-013e472d=\"\"> <a v-link=\"{ path: '/' }\" _v-013e472d=\"\"> <img src=" + __webpack_require__(771) + " style=\"height: 20px; whith: 120px; margin-bottom: -5px\" alt=UmiUni北美校友圈 _v-013e472d=\"\"> <h1 style=display:inline-block;font-size:12px;padding:0;margin:0;margin-left:-10px _v-013e472d=\"\"><span style=\"display: none\" _v-013e472d=\"\">UmiUni</span>北美校友圈</h1> </a> </li> <a class=\"mobile-only navigation-button\" @click=toggleQR() _v-013e472d=\"\"> <img width=10% height=10% class=school-logo :src=\"OSS + 'app_images/wechat_mini_iconLogo'\" _v-013e472d=\"\"> </a> <a class=\"mobile-only navigation-button\" onclick=\"window.location.href='https://itunes.apple.com/us/app/umiuni/id1265697567?mt=8'\" _v-013e472d=\"\"> <img width=10% height=10% class=school-logo :src=\"OSS + 'app_images/iphone_app_storeLogo'\" _v-013e472d=\"\"> </a> <li class=pc-only _v-013e472d=\"\"> <div class=search-bar-container _v-013e472d=\"\"> <div class=search-bar _v-013e472d=\"\"> <input v-model=query.name class=search-content autocomplete=off type=text placeholder=名称 @keyup.enter=search _v-013e472d=\"\"> <a class=search-type _v-013e472d=\"\"> {{ types[query.type] }} <ul class=dropdown _v-013e472d=\"\"> <li v-for=\"type in keys(types)\" @click=\"query.type = type\" _v-013e472d=\"\">{{ types[type] }}</li> </ul> </a> <icon v-if=!typeMenuToggle type=ios-arrow-down _v-013e472d=\"\"></icon> <icon v-else=\"\" type=ios-arrow-up _v-013e472d=\"\"></icon> <button v-link=\"{ name: 'search', query: query }\" class=search-btn data-market=搜索栏;搜索Button _v-013e472d=\"\"> <icon type=search _v-013e472d=\"\"></icon> {{ $t(`operate.search`) }} </button> </div> </div> </li> <li class=\"right pc-only\" _v-013e472d=\"\"> <div class=button-group _v-013e472d=\"\"> <a v-link=\"{ path: '/sell' }\" class=button _v-013e472d=\"\">发布</a> </div> </li> <li v-if=\"login &amp;&amp; info.authority == 2 &amp;&amp; false\" class=\"right pc-only\" _v-013e472d=\"\"> <a v-link=\"{ name: 'message' }\" class=line _v-013e472d=\"\"> <badge _v-013e472d=\"\"> <span _v-013e472d=\"\"><icon type=ios-email-outline size=24 _v-013e472d=\"\"></icon></span> </badge> </a> </li> <li v-if=!login class=\"right pc-only\" _v-013e472d=\"\"> <a v-link=\"{ path: '/signup' }\" class=line _v-013e472d=\"\"> {{ $t('user.signup') }} </a> </li> <li v-if=!login class=\"right pc-only\" _v-013e472d=\"\"> <a v-link=\"{ path: '/login' }\" class=\"line user\" _v-013e472d=\"\"> {{ $t('user.login') }} </a> </li> <li v-if=login v-clickoutside=handleMenuClickOutSide class=\"right pc-only\" _v-013e472d=\"\"> <a class=\"line user\" @click=\"menuToggle = !menuToggle\" _v-013e472d=\"\"> <div class=avatar :style=\"{ backgroundImage: `url(${OSS + info.avatar})` }\" _v-013e472d=\"\"></div> <span _v-013e472d=\"\">{{ info.username }}</span> &nbsp;<icon type=ios-arrow-down _v-013e472d=\"\"></icon> </a> <ul class=dropdown :class=\"{ active: menuToggle }\" @click=\"menuToggle = false\" _v-013e472d=\"\"> <li v-link=\"{ path: '/user/profile' }\" _v-013e472d=\"\"> <icon type=person class=menu-icon _v-013e472d=\"\"></icon>{{ $t(`user.profile`) }} </li> <li v-link=\"{ path: '/user/forum' }\" _v-013e472d=\"\"> <icon type=chatboxes class=menu-icon _v-013e472d=\"\"></icon>论坛 </li> <li v-link=\"{ path: '/user/like' }\" _v-013e472d=\"\"> <icon type=heart class=menu-icon _v-013e472d=\"\"></icon>{{ $t(`user.like`) }} </li> <li v-link=\"{ path: '/user/manage' }\" _v-013e472d=\"\"> <icon type=navicon-round class=menu-icon _v-013e472d=\"\"></icon>{{ $t(`user.manage`) }} </li> <li v-link=\"{ name: 'u', params: { userid: info.userid } }\" _v-013e472d=\"\"> <icon type=home class=menu-icon _v-013e472d=\"\"></icon>{{ $t(`user.personal`) }} </li> <li v-link=\"{ path: '/sell' }\" class=divided _v-013e472d=\"\"> <icon type=paper-airplane class=menu-icon _v-013e472d=\"\"></icon>{{ $t(`operate.sell`) }} </li> <li v-link=\"{ name: 'secure' }\" _v-013e472d=\"\"> <icon type=android-hand class=menu-icon _v-013e472d=\"\"></icon>{{ $t(`user.secure`) }} </li> <li v-link=\"{ path: '/user/logout' }\" class=divided _v-013e472d=\"\"> <icon type=log-out class=menu-icon _v-013e472d=\"\"></icon>{{ $t(`user.logout`) }} </li> </ul> </li> <li v-if=login _v-013e472d=\"\"> <a class=line @click=this.signIn() _v-013e472d=\"\"> <div _v-013e472d=\"\"> <row _v-013e472d=\"\"> <p style=font-size:15px;font-color:#FF0000 _v-013e472d=\"\">【签到】</p> </row> </div> </a> </li> <a href=https://umiuni.com target=_blank _v-013e472d=\"\"> <icon class=icon _v-013e472d=\"\"></icon> <span style=\"color: orange\" _v-013e472d=\"\">【新站点】</span> </a> <li v-clickoutside=handleLocationClickOutside class=right font-color:=\"\" _v-013e472d=\"\"> <a class=line @click=\"this.locationToggle = !this.locationToggle\" _v-013e472d=\"\"> <div _v-013e472d=\"\"> <row _v-013e472d=\"\"> <p style=font-size:15px _v-013e472d=\"\">【学校：{{school.abbr}}】<icon type=ios-arrow-down _v-013e472d=\"\"></icon></p> </row> </div> </a> </li> <ul v-if=school class=\"card dropdown right\" style=\"z-index:300; position:absolute; padding: 10px; text-align: center; margin-left:57%;margin-right:10%;height:auto;width:auto\" :class=\"{ active: locationToggle }\" @click=\"locationToggle = false\" _v-013e472d=\"\"> <p _v-013e472d=\"\">当前学校: {{ school.name }}</p> <i-button long=\"\" @click=setSchool(null) _v-013e472d=\"\"> 更改学校 </i-button> <i-button long=\"\" style=\"margin-top: 10px\" v-link=\"{ path: '/user/profile' }\" _v-013e472d=\"\"> 默认学校 </i-button> </ul> </ul> </header> <div class=\"mobile-only qr-fixed-right\" :class=\"{ active: toggleQRActive}\" _v-013e472d=\"\"> <img src=" + __webpack_require__(773) + " width=240 _v-013e472d=\"\"> </div> <div v-if=\"info.authority == 2\" style=\"position: fixed; left: 0; top: 0; z-index: 10001; padding: 3px\" _v-013e472d=\"\"> Admin </div> <ul class=\"mobile-nav mobile-only unselectable\" _v-013e472d=\"\"> <li _v-013e472d=\"\"> <a v-link=\"{ name: 'index' }\" :class=\"{ active: $route.name === 'index' }\" _v-013e472d=\"\"> <icon type=ios-home-outline class=icon _v-013e472d=\"\"></icon> <span _v-013e472d=\"\">主页</span> </a> </li> <li _v-013e472d=\"\"> <a v-link=\"{ name: 'search', query: { type: 'event' } }\" :class=\"{ active: $route.name === 'secure' }\" _v-013e472d=\"\"> <icon type=beer class=icon _v-013e472d=\"\"></icon> <span _v-013e472d=\"\">活动</span> </a> </li> <li _v-013e472d=\"\"> <a v-link=\"{ name: 'sell' }\" :class=\"{ active: $route.name === 'sell' }\" _v-013e472d=\"\"> <icon type=ios-plus-empty class=icon _v-013e472d=\"\"></icon> <span _v-013e472d=\"\">发布</span> </a> </li> <li _v-013e472d=\"\"> <a @click=\"classToggle = !classToggle\" _v-013e472d=\"\"> <icon type=ios-pricetags-outline class=icon _v-013e472d=\"\"></icon> <span _v-013e472d=\"\">分类</span> </a> </li> <li _v-013e472d=\"\"> <a v-link=\"{ path: '/user/nav' }\" :class=\"{ active: $route.path.split('/')[1] === 'user' }\" _v-013e472d=\"\"> <icon type=ios-person-outline class=icon _v-013e472d=\"\"></icon> <span _v-013e472d=\"\">账号管理</span> </a> </li> </ul> <div v-show=classToggle slot=content class=\"classification full float\" transition=pull @click.prevent=\"classToggle = false\" _v-013e472d=\"\"> <ul class=dropdown _v-013e472d=\"\"> <li v-for=\"type in keys(types)\" @click=\"query.type = type\" _v-013e472d=\"\"> <div class=hr _v-013e472d=\"\"> <span v-link=\"{ name: 'search', query: { type: type } }\" _v-013e472d=\"\">{{ types[type] }}</span> </div> <div v-if=tagList class=tag-list _v-013e472d=\"\"> <span v-for=\"tag in tagList[type]\" v-link=\"{ name: 'search', query: { type: type, tag: tag } }\" _v-013e472d=\"\">{{ tag }}</span> </div> </li> </ul> </div> ";

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <footer class=unselectable _v-3fe8398a=\"\"> <div class=container _v-3fe8398a=\"\"> <div class=back-to-top @click=backToTop _v-3fe8398a=\"\"> {{ $t(`operate.backToTop`) }} </div> <ul class=\"catagory pc-only\" _v-3fe8398a=\"\"> <li _v-3fe8398a=\"\"> <p _v-3fe8398a=\"\">分类</p> <ul class=item _v-3fe8398a=\"\"> <li v-for=\"type in keys(types)\" _v-3fe8398a=\"\"> <a v-link=\"{ name: 'search', query: { 'type': type } }\" _v-3fe8398a=\"\">{{ types[type] }}</a> </li> </ul> </li> <li v-for=\"c in menu\" _v-3fe8398a=\"\"> <p _v-3fe8398a=\"\">{{ c.title }}</p> <ul class=item _v-3fe8398a=\"\"> <li v-for=\"i in c.items\" _v-3fe8398a=\"\"> <a v-if=\"i.hasOwnProperty('link')\" v-link=\"{ name: i.link || 'index' }\" :class=\"{ disabled: !!i.disabled}\" _v-3fe8398a=\"\">{{ i.title }}</a> <a v-if=\"i.hasOwnProperty('href')\" :href=i.href :class=\"{ disabled: !!i.disabled}\" _v-3fe8398a=\"\">{{ i.title }}</a> </li> </ul> </li> <li _v-3fe8398a=\"\"> <img style=\"height:150px; width:150px\" src=" + __webpack_require__(147) + " width=150 _v-3fe8398a=\"\"> </li> </ul> <hr _v-3fe8398a=\"\"> <div class=copyright _v-3fe8398a=\"\"> © alumni.umiuni.com, 2016-2040. </div> </div> </footer> ";

/***/ }),

/***/ 801:
/***/ (function(module, exports) {

	module.exports = " <div class=school-select-modal _v-a77512e0=\"\"> <modal :visible.sync=visible :closable=false :mask-closable=false :width=600 _v-a77512e0=\"\"> <i-col span=6 class=\"state-list-container list-container\" _v-a77512e0=\"\"> <ul class=state-list _v-a77512e0=\"\"> <li :class=\"{ active: currentState === 'hot'}\" @click=\"currentState = 'hot'\" _v-a77512e0=\"\"> 热门 </li> <li v-for=\"state in stateList\" :class=\"{ active: currentState === state }\" @click=\"currentState = state\" _v-a77512e0=\"\"> {{ state }} </li> </ul> </i-col> <i-col span=18 class=\"school-list-container list-container\" _v-a77512e0=\"\"> <ul class=school-list _v-a77512e0=\"\"> <li v-for=\"school in currentSchoolList\" style=\"cursor: pointer\" @click=handleSchoolClick(school) _v-a77512e0=\"\"> <b _v-a77512e0=\"\">{{ school.abbr }}</b>{{ school.name }} </li> </ul> </i-col> </modal> </div> ";

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(515)
	__vue_script__ = __webpack_require__(205)
	__vue_template__ = __webpack_require__(774)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(533)
	__vue_script__ = __webpack_require__(209)
	__vue_template__ = __webpack_require__(787)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(521)
	__vue_script__ = __webpack_require__(213)
	__vue_template__ = __webpack_require__(775)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(519)
	__webpack_require__(547)
	__vue_script__ = __webpack_require__(241)
	__vue_template__ = __webpack_require__(801)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 857:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.js